'use client'
import { Table, TableRow, TableHeader, TableCell, SmartLink, ColorButton, Pagination, MoreButton } from "@/components/ui";
import { ClientSellerResponse, PaginationParams } from "@/types";
import React, { useEffect, useState } from "react";
import { Pen, Trash } from "@/assets/icons";
import { listClientsBySeller } from "@/app/api";

export function ManageClientSeller({ id }: { id: string }) {
    const [showObservation, setShowObservation] = useState<Record<string, boolean>>({})
    const [clientSellersData, setClientSellersData] = useState<ClientSellerResponse>()
    const [filters, setFilters] = useState<PaginationParams>({
        page: 1,
        perPage: 10,
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await listClientsBySeller(id, filters)
                setClientSellersData(data)
            } catch (err) {
                console.log("Erro ao carregar usuários: ", err);
            }
        }

        fetchUsers()
    }, [id, filters]);

    const clientSellers = clientSellersData?.data || []

    const toggleExpand = (visitorId: string) => {
        setShowObservation(prev => ({
            ...prev,
            [visitorId]: !prev[visitorId]
        }))
    }

    const handlePageChange = (page: number) => {
        setFilters({ ...filters, page });
    };

    return (
        <div className="pt-8">
            <div className="flex justify-between">
                <SmartLink type={"internal"} route={"adminSellerIdClientsIdNew"}
                    params={[`${id}`]}>
                    <ColorButton>Cadastro</ColorButton>
                </SmartLink>
            </div>

            <div className="p-8">
                <div className="hidden md:flex">
                    <Table>
                        <thead>
                            <TableRow>
                                <TableHeader>Código</TableHeader>
                                <TableHeader>Empresa</TableHeader>
                                <TableHeader>Nome</TableHeader>
                                <TableHeader>Status</TableHeader>
                                <TableHeader>Data do Cadastro</TableHeader>
                                <TableHeader>Data da Atualização</TableHeader>
                                <TableHeader></TableHeader>
                            </TableRow>
                        </thead>
                        <tbody>
                            {clientSellers.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} className="text-center">
                                        Não existem clientes para esse vendedor.
                                    </TableCell>
                                </TableRow>
                            ) : (clientSellers.map((clientSeller) => (
                                <React.Fragment key={clientSeller.id}>
                                    <TableRow>
                                        <TableCell>{clientSeller.client.code}</TableCell>
                                        <TableCell>{clientSeller.client.userName}</TableCell>
                                        <TableCell>{clientSeller.client.name}</TableCell>
                                        <TableCell>
                                            {clientSeller.client.role === 'CLIENT' ? 'Ativo'
                                                : clientSeller.client.role === 'INACTIVE' ? 'Inativo'
                                                    : clientSeller.client.role === 'CANCELED' ? 'Cancelado'
                                                        : '- - - - -'
                                            }
                                        </TableCell>
                                        <TableCell>{new Date(clientSeller.createdAt).toLocaleDateString()}</TableCell>
                                        {clientSeller.updatedAt === clientSeller.createdAt
                                            ?
                                            <TableCell> {"- - - - -"} </TableCell>
                                            :
                                            <TableCell>{new Date(clientSeller.updatedAt).toLocaleDateString()}</TableCell>
                                        }
                                        <TableCell>
                                            <MoreButton onClick={() => toggleExpand(clientSeller.id)} />
                                        </TableCell>
                                    </TableRow>
                                    {showObservation[clientSeller.id] && (
                                        <TableRow>
                                            <TableHeader colSpan={2}>Observação</TableHeader>
                                            <TableCell colSpan={4}>{clientSeller.observation}</TableCell>
                                            <TableCell className="flex flex-col gap-3">
                                                {clientSeller.client.role === 'INACTIVE'
                                                    ? ''
                                                    : clientSeller.client.role === 'CANCELED'
                                                        ? ''
                                                        : <SmartLink type={"internal"} route={"adminSellerIdClientsIdUpdate"}
                                                            params={[`${id}`, `${clientSeller.id}`]}>
                                                            <Pen />
                                                        </SmartLink>
                                                }

                                                <SmartLink type={"internal"} route={"adminSellerIdClientsIdDelete"}
                                                    params={[`${id}`, `${clientSeller.id}`]}>
                                                    <Trash />
                                                </SmartLink>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))
                            )
                            }
                        </tbody>

                    </Table>
                </div>

                <div className="flex md:hidden">
                    <Table>
                        <tbody>
                            {clientSellers.length === 0 ? (
                                <TableRow>
                                    <TableCell className="text-center">
                                        Não existem clientes para esse vendedor.
                                    </TableCell>
                                </TableRow>
                            ) : (clientSellers.map((clientSeller) => (
                                <TableRow key={clientSeller.id}>
                                    <TableHeader>Código</TableHeader>
                                    <TableCell>{clientSeller.client.code}</TableCell>
                                    <TableHeader>Empresa</TableHeader>
                                    <TableCell>{clientSeller.client.userName}</TableCell>
                                    <TableHeader>Nome</TableHeader>
                                    <TableCell>{clientSeller.client.name}</TableCell>
                                    <TableHeader>Status</TableHeader>
                                    <TableCell>
                                        {clientSeller.client.role === 'CLIENT' ? 'Ativo'
                                            : clientSeller.client.role === 'INACTIVE' ? 'Inativo'
                                                : clientSeller.client.role === 'CANCELED' ? 'Cancelado'
                                                    : '- - - - -'
                                        }
                                    </TableCell>
                                    <TableHeader>Data do cadastro</TableHeader>
                                    <TableCell>{new Date(clientSeller.createdAt).toLocaleDateString()}</TableCell>
                                    <TableHeader>Data da Atualização</TableHeader>
                                    {clientSeller.updatedAt === clientSeller.createdAt
                                        ?
                                        <TableCell> {"- - - - -"} </TableCell>
                                        :
                                        <TableCell>{new Date(clientSeller.updatedAt).toLocaleDateString()}</TableCell>
                                    }
                                    <TableHeader>Observação</TableHeader>
                                    <TableCell>{clientSeller.observation}</TableCell>
                                    <TableCell className="flex gap-10">
                                        {clientSeller.client.role === 'INACTIVE'
                                            ? ''
                                            : clientSeller.client.role === 'CANCELED'
                                                ? ''
                                                : <SmartLink type={"internal"} route={"adminSellerIdClientsIdUpdate"}
                                                    params={[`${id}`, `${clientSeller.id}`]}>
                                                    <Pen />
                                                </SmartLink>
                                        }
                                        <SmartLink type={"internal"} route={"adminSellerIdClientsIdDelete"}
                                            params={[`${id}`, `${clientSeller.id}`]}>
                                            <Trash />
                                        </SmartLink>
                                    </TableCell>
                                    <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                                </TableRow>
                            )))}
                        </tbody>
                    </Table>
                </div>
            </div>

            <div>
                {clientSellersData?.pagination &&
                    <Pagination
                        currentPage={clientSellersData.pagination.page}
                        totalPages={Math.ceil(clientSellersData.pagination.total / clientSellersData.pagination.perPage)}
                        onPageChange={handlePageChange}
                    />
                }
            </div>
        </div>
    )
}